import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDuvjcLv2GiiTPiLLO43MaJi9hQ5Bw16QQ",
  authDomain: "christian-speed-dating.firebaseapp.com",
  projectId: "christian-speed-dating",
  storageBucket: "christian-speed-dating.firebasestorage.app",
  messagingSenderId: "427137955429",
  appId: "1:427137955429:web:e05aa78f53597e35a2388c",
  measurementId: "G-PB0WPW6T1R"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);